import { useUserStore } from '~/stores/user'

export default defineNuxtRouteMiddleware(async () => {
  const user = useUserStore()
  if (!await user.checkAdmin()) {
    return navigateTo('/portal')
  }
})
